
import WalletModule from './views/Module.vue';
import Wallet from './views/Wallet.vue';
import WalletDeposit from './views/WalletDeposit.vue';
import WalletWithdraw from './views/WalletWithdraw.vue';
import WalletHistory from './views/WalletHistory.vue';
import TransactionDetails from './views/TransactionDetails.vue';
import DepositPaymentMethod from './views/DepositPaymentMethod.vue';
import WithdrawDetails from './views/WithdrawDetails.vue';
import WithdrawAccountDetails from './views/WithdrawAccountDetails.vue';


const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
      {
        path: 'wallet',
        name: 'Wallet',
        component: Wallet,
        meta: { title: 'Wallet' }
      },
      {
        path: 'wallet-deposit',
        name: 'WalletDeposit',
        component: WalletDeposit,
        meta: { title: 'Wallet Deposit' }
      },
      {
        path: 'wallet-withdraw',
        name: 'WalletWithdraw',
        component: WalletWithdraw,
        meta: { title: 'Wallet Withdraw' }
      },
      {
        path: 'wallet-history',
        name: 'WalletHistory',
        component: WalletHistory,
        meta: { title: 'Wallet History' }
      },
      {
        path: 'transaction-details/:id',
        name: 'TransactionDetails',
        component: TransactionDetails,
        meta: { title: 'Transaction Details' }
      },
      {
        path: 'deposit-payment',
        name: 'DepositPaymentMethod',
        component: DepositPaymentMethod,
        meta: { title: 'Deposit Payment' }
      },
      {
        path: 'withdraw-details',
        name: 'WithdrawDetails',
        component: WithdrawDetails,
        meta: { title: 'Withdraw Details' }
      },
      {
        path: 'add-new-account/:type/:id',
        name: 'WithdrawAccountDetails',
        component: WithdrawAccountDetails,
        meta: { title: 'Add new Account' }
      },
    ],
}
export default WalletRoutes;